import {
  EnvironmentProviders,
  inject,
  Provider,
  provideAppInitializer,
} from '@angular/core';
import { MAT_DATE_LOCALE, MatDateFormats, provideNativeDateAdapter } from '@angular/material/core';

import { DateFnsLocaleService } from './date-fns-locale.service';
import { MatDateLocaleSyncService } from './mat-date-locale-sync.service';
import { PAYEE_NATIVE_DATE_FORMATS } from './payee-native-date-formats';

export function providePayeeDate(
  formats: MatDateFormats = PAYEE_NATIVE_DATE_FORMATS,
  defaultLocale = 'hu',
): (Provider | EnvironmentProviders)[] {
  return [
    { provide: MAT_DATE_LOCALE, useValue: defaultLocale },
    ...provideNativeDateAdapter(formats),
    MatDateLocaleSyncService,
    DateFnsLocaleService,
    provideAppInitializer(() => {
      inject(DateFnsLocaleService);
      inject(MatDateLocaleSyncService);
    }),
  ];
}
